module.exports = __webpack_public_path__ + "media/images/official/award_2-f5497f32cace7077f79e8303e4ae3379.png";